module.exports = __webpack_public_path__ + "media/images/prevBtn-370c8356b4f47329e65b9b12625d8a99.svg";